/* Medical records and data-subject rights (docs/plans/phase2-records-data-rights.md §6).
 * Tokens only. */

.page {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
  min-width: 0;
}

.toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
}

.meta {
  margin: 0;
  color: var(--graphite);
  font: var(--t-small);
}

/* Prose: requests, responses and the retention explanation (DESIGN.md §3, 75 characters). */
.prose {
  max-width: 75ch;
  margin: 0;
  white-space: pre-wrap;
}

.facts {
  display: grid;
  grid-template-columns: max-content minmax(0, 1fr);
  gap: var(--space-1) var(--space-4);
  margin: 0;
}

.facts dt {
  color: var(--graphite);
}

.facts dd {
  margin: 0;
  overflow-wrap: anywhere;
}

.numbers {
  font-variant-numeric: tabular-nums;
}

/* One change a correction can point to: what, who and when, and the choice. */
.candidates {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  list-style: none;
}

.candidate {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: var(--space-3);
  min-height: 44px;
  padding: var(--space-2) 0;
  border-bottom: 1px solid var(--rule);
}

/* The printed summary: sections flow onto as many A4 pages as they need. */
.printSection {
  margin-top: 5mm;
  break-inside: auto;
}

.printSection h2 {
  margin: 0 0 2mm;
  font-size: 1.1em;
  font-weight: 700;
}

.printSection h3 {
  margin: 3mm 0 1mm;
  font-size: 1em;
  font-weight: 700;
}

.printSection p {
  margin: 0 0 1.5mm;
}

.printNote {
  white-space: pre-wrap;
}

.preview {
  max-width: 100%;
  overflow-x: auto;
}

@media (width < 600px) {
  .facts {
    grid-template-columns: minmax(0, 1fr);
  }
}
